
//https://uicolors.app/create
const COLORS = {
    'blue': {
        '50': '#f3f7fc',
        '100': '#e7f0f7',
        '200': '#c9dfee',
        '300': '#9ac5df',
        '400': '#7ab2d3', //Base
        '500': '#408ab7',
        '600': '#2f6e9a',
        '700': '#27597d',
        '800': '#244c68',
        '900': '#234157',
        '950': '#172a3a',
    },
    'red': {
        '50': '#fcf4f4',
        '100': '#f9ecea',
        '200': '#f3d9d8',
        '300': '#e8bbb9',
        '400': '#db9391',
        '500': '#c96868', //base
        '600': '#b34b50',
        '700': '#963a41',
        '800': '#7e333b',
        '900': '#6d2e37',
        '950': '#3b161a',
    },
    'green': {
        '50': '#f3faf3',
        '100': '#e3f5e4',
        '200': '#c9e9cb',
        '300': '#9ed7a3',
        '400': '#72bf78', //base
        '500': '#47a04e',
        '600': '#36833c',
        '700': '#2d6832',
        '800': '#28532c',
        '900': '#224526',
        '950': '#0e2511',
    },
    'orange': {
        '50': '#fdf7ef',
        '100': '#faecda',
        '200': '#f4d5b4',
        '300': '#edb884',
        '400': '#e59252',
        '500': '#e07b39', //base
        '600': '#d05e26',
        '700': '#ad4821',
        '800': '#8a3a22',
        '900': '#70321e',
        '950': '#3c170e',
    },
    'slate': {
        '50': '#f3f7f8',
        '100': '#e0eaed',
        '200': '#c4d7dd',
        '300': '#9ab9c6',
        '400': '#6a94a6',
        '500': '#4f798b',
        '600': '#446376',
        '700': '#3c5362',
        '800': '#384955', //base
        '900': '#313e48',
        '950': '#1d272f',
    },

    'blue-lisaqua': {
        '50': '#eef8ff',
        '100': '#dcf1ff',
        '200': '#b2e6ff',
        '300': '#6dd3ff',
        '400': '#20bcff',
        '500': '#00a4ff',
        '600': '#0082df',
        '700': '#0067b4',
        '800': '#005795',
        '900': '#00487a',
        '950': '#00325a',
    },
    'blue-2-lisaqua': {
        '50': '#eafeff',
        '100': '#cbfcff',
        '200': '#9ef6ff',
        '300': '#5becff',
        '400': '#11d8ff',
        '500': '#00bce5',
        '600': '#0095c0',
        '700': '#03769b',
        '800': '#0d5f7d', //base
        '900': '#104e69',
        '950': '#033349',
    },
    
    'red-lisaqua': {
        '50': '#fff0f3',
        '100': '#ffe1e8',
        '200': '#ffc8d6',
        '300': '#ff9bb5',
        '400': '#ff638f',
        '500': '#ff2c6e',
        '600': '#f6085b',
        '700': '#d0004e', //base
        '800': '#ae0348',
        '900': '#940744',
        '950': '#530021',
    },
    
    'green-lisaqua': {
        '50': '#f0fafb',
        '100': '#daf1f3',
        '200': '#b9e4e8',
        '300': '#88ced8',
        '400': '#50b0c0',
        '500': '#3494a6',
        '600': '#2e798c',
        '700': '#2b6273',
        '800': '#2d5765', //base
        '900': '#274652',
        '950': '#152d37',
    },
    
    'orange-lisaqua': {
        '50': '#fef3f2',
        '100': '#fde5e3',
        '200': '#fdcecb',
        '300': '#faaca7',
        '400': '#f57c74',
        '500': '#ec544a', //base
        '600': '#d93429',
        '700': '#b6281f',
        '800': '#97251d',
        '900': '#7d251f',
        '950': '#440f0b',
    },
    //https://uicolors.app/generate/222326
    "dark": {
        '50': '#f5f6f6',
        '100': '#e5e7e8',
        '200': '#cdd0d4',
        '300': '#abafb5',
        '400': '#81868f',
        '500': '#666b74',
        '600': '#575b63',
        '700': '#4a4d54',
        '800': '#424448',
        '900': '#3a3c3f',
        '950': '#222326', //primary
        '1000': '#111316', //primary
    },
}

export const REQUEST_IA_COLOR = "#bcd730"
export const REQUEST_IA_COMPARED_COLORS = ["#aaa730", "#999730", "#666730", "#222730", "#000730", "#000730", "#000730", "#000730"]
export const BATCH_COLORS = {
    batch: "#0d5f7d",
    batchModel: "#9ab9c6",
    batchTarget: "#FB8500",
    mtd: "#faaca7",
    ytd: "#940744",
}
export const SHRIMPWEIGHING_ERROR_COLORS = {
    "OK": "#007f65",
    "001": "#f57c74", //"Dechet (0)"
    "071": "#f57c74", //"Dechet bac plein"
    "080": "#0095c0", //"Dechet hors calibre"
    "100": "#940744", //"Dechet mal pese"
    "101": "#940744", //"Dechet erreur mise a →0←"
    "109": "#940744", //"Dechet: attente 1 tour"
    "200": "#940744", //"Dechet produit trop pres1"
    "201": "#940744", //"Dechet produit trop pres2"
    "202": "#940744", //"Dechet produit trop long"
    "400": "#940744", //"Dechet (1)"
    "401": "#940744", //"Dechet (2)"
}

export const STORAGE_COLORS_CLASSNAME = {
    1: "bg-red-200",
    2: "bg-blue-200",
}

export const PACKAGING_COLORS_CLASSNAME = {
    1: "bg-opacity-40",
    2: "bg-opacity-30",
    3: "bg-opacity-20",
    4: "bg-opacity-10",
    5: "bg-opacity-5",
}
export const VALUES_COLORS = {
    adjustmentCoef: "#8ECAE6",
    alkalinity: "#219EBC",
    ammonium: "#8ECAE6",
    avgCaliber: "#165076",
    avgWeight: "#8ECAE6",
    avgWeightZA: "#8ECAE6",
    avgWeightZB: "#8ECAE6",
    avgWeightZC: "#8ECAE6",
    bicarbonate: "#6C757D",
    biomass: "#8ECAE6",
    biomassTarget: "#47a04e",
    biomassSellable: "#7ab2d3",
    biomassNotSellable: "#ffdab9",
    biomassNotEatable: "#c96868",
    black: "#000814",
    brokenAntennas: "#ffdab9",
    calcium: "#8ECAE6",
    calibrationQuality: "#05b489",
    cannibalism: "#f8ad9d",
    coefficientVar: "#8ECAE6",
    concentration: "#8E91E6",
    description: "#8ECAE6",
    digestiveTracts: "#ccd5ae",
    faeces: "#bde0fe",
    feedingRate: "#E76F51",
    foodQuantity: "#E76F51",
    foodQuantityLinked: "#E7aa51",
    foodQuantityTarget: "#F4A261",
    foodTypeProportion: "#8ECAE6",
    greenBig: "#386641",
    greenSmall: "#6A994E",
    gillPlugging: "#cdb4db",
    length: "#8ECAE6",
    leftovers: "#ffafcc",
    magnesium: "#8ECAE6",
    massGain: "#8ECAE6",
    mes: "#606C38",
    mortality: "#a2d2ff",
    moults: "#a2d2ff",
    mud: "#8ECAE6",
    necrosis: "#7ab2d3",
    nitrate: "#8ECAE6",
    nitrite: "#2A9D8F",
    oxygen: "#778DA9",
    pellets: "#8ECAE6",
    ph: "#606C38",
    phosphate: "#8ECAE6",
    phosphorus: "#8ECAE6",
    potassium: "#8ECAE6",
    quantity: "#8ECAE6",
    ratioAllGreenTotalFlora: "#8ECAE6",
    ratioConcentrationOnTotalFlora: "#8ECAE6",
    salinity: "#8ECAE6",
    salinityAfter: "#8ECAE6",
    salinityVar: "#8ECAE6",
    salt: "#8ECAE6",
    seaweed: "#8ECAE6",
    shrimpCount: "#8ECAE6",
    shrimpPerLandingNet: "#8ECAE6",
    shrimpCountZA: "#8ECAE6",
    shrimpCountZB: "#8ECAE6",
    shrimpCountZC: "#8ECAE6",
    shrimpsDead: "#8ECAE6",
    shrimpsObserved: "#8ECAE6",
    sortingQuality: "#05b489",
    stadePL: "#8ECAE6",
    sugar: "#878479",
    temperature: "#F4A261",
    temperatureVar: "#F4A261",
    time: "#8ECAE6",
    totalFlora: "#8E50E6",
    transportTime: "#8ECAE6",
    tss: "#BC6C25",
    urea: "#8ECAE6",
    volume: "#8ECAE6",
    volumeL: "#8ECAE6",
    waterHeight: "#8ECAE6",
    weight: "#8ECAE6",
    width: "#8ECAE6",
    yellow: "#E9C46A",

    average: "#CB9DF0",
    median: "#F0C1E1",
    quartile1: "#FDDBBB",
    quartile3: "#FDDBBB",
    standardDeviation: "#FFF9BF", 
  }

export const TARGET_COLORS = [
    COLORS.green["500"],
    COLORS.green["300"],
]
export const numberToPastelColor = (number: number): string => {
    // Convert the input number to a more complex, non-linear hash for hue variation
    let hash = Math.abs(((number * 2654435761) % Math.pow(2, 32)) / Math.pow(2, 24));

    // Use the hash to generate a hue value between 0 and 360
    let hue = Math.floor(hash * 360); // Hue value determines the color

    // Set saturation and lightness to get a pastel-like effect
    let saturation = 60; // Saturation at 60% for a soft color
    let lightness = 70; // Lightness at 85% for a pastel effect

    // Return the HSL color as a string
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}



export const COLORS_CLASSNAME_BY_EVENTTYPE = {
   "UPDATE" : "text-blue-600",
   "INSERT" : "text-green-600",
   "DELETE" : "text-red-600"
}



export default COLORS;